import { closePopup } from "@/helper/DxHelper";
import { calculateAge } from "./up-utils";
import { uqActions } from "@/redux/uq/uq-slice";
import { CalculateGrid } from "@/redux/uq/uq-actions";
import { Popup } from "devextreme-react";
import CustomButton from "@/components/CustomButton";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { PopupRef } from "devextreme-react/cjs/popup";
import { useAppSelector } from "@/hooks/useAppSelector";
import { UNIQUE_POSSIBILITIES } from "@/constants/constants";

type Props = {
  resetPopupRef: React.RefObject<PopupRef>;
};

export default function ResetPopup({ resetPopupRef }: Props) {
  const dispatch = useAppDispatch();
  const { household } = useAppSelector((state) => state.uq);
  const resetUp = () => {
    dispatch(uqActions.setReload(true));

    const p1Age = calculateAge(household?.primaryContact?.birthDate.toString(), 0);
    let p2Age = 0;

    if (household?.secondaryContact)
      p2Age = calculateAge(household?.secondaryContact.birthDate.toString(), 0).value;

    dispatch(
      uqActions.setSettings({
        inflation: 0.035,
        cola: 0.025,
        ror: 0.07,
        person1: {
          beginAt:
            p1Age.value > UNIQUE_POSSIBILITIES.MinAge ? p1Age.value : UNIQUE_POSSIBILITIES.MinAge,
          amount: 0,
          showAge: true,
          showSS: true,
        },
        person2: {
          beginAt: p2Age > UNIQUE_POSSIBILITIES.MinAge ? p2Age : UNIQUE_POSSIBILITIES.MinAge,
          amount: 0,
          showAge: true,
          showSS: true,
        },
        showSS: false,
        showRor: false,
      })
    );
    dispatch(CalculateGrid(0, []));

    setTimeout(() => {
      dispatch(uqActions.setReload(false));
    }, 1000);
    dispatch(uqActions.setIsModified(true));
  };

  return (
    <Popup width={450} height="fit" ref={resetPopupRef} hideOnOutsideClick={true} showTitle={false}>
      <div className="flex flex-col gap-5">
        <h2 className="text-center text-lg font-medium">
          Do you want to reset Unique Possibilities?
        </h2>
        <div className="flex justify-center gap-4">
          <CustomButton
            className="px-7 py-[10px]"
            text="Cancel"
            variant="default"
            onClickHandler={() => closePopup(resetPopupRef)}
          />
          <CustomButton
            className="px-7 py-[10px]"
            text="Reset"
            variant="primary"
            onClickHandler={resetUp}
          />
        </div>
      </div>
    </Popup>
  );
}
